import React, { useState, useEffect, useCallback } from "react";
import Web3 from "web3";
import { UserAuth } from '../../context/AuthContext'
import { Oval } from 'react-loader-spinner';
import { MdPowerSettingsNew } from 'react-icons/md';
import { FiCheckCircle } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { SiBinance } from 'react-icons/si';


export default function App() {
    const { user, savePayment } = UserAuth();
    const uname = user.displayName;

    const [walletConnected, setWalletConnected] = useState(false);
    const [web3, setWeb3] = useState(null);
    const [myAddress, setMyAddress] = useState('')
    const [connStatus, setConnStatus] = useState('no action');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const onAccountsChanged = useCallback(async (accounts) => {
        if (accounts.length > 0 && !walletConnected) {
            console.log("Connected to wallet with address:", accounts[0]);
            setWalletConnected(true);
        } else if (accounts.length === 0 && walletConnected) {
            console.log("Wallet disconnected");
            setWalletConnected(false);
            setWeb3(null); // Reset web3 instance
        }
    }, [walletConnected]);

    useEffect(() => {
        if (web3) {
            window.ethereum.on("accountsChanged", onAccountsChanged);
            return () => {
                window.ethereum.removeListener("accountsChanged", onAccountsChanged);
            };
        }
    }, [web3, onAccountsChanged]);

    const connectWallet = async () => {
        try {
            const ethereum = window.ethereum;
            if (ethereum) {
                setLoading(true);
                setConnStatus('Connecting to wallet...');
                const newWeb3 = new Web3(ethereum);
                const accounts = await ethereum.request({ method: "eth_requestAccounts" });
                if (accounts.length > 0) {
                    console.log("Already connected to wallet with address:", accounts[0]);
                    setMyAddress(accounts[0]);
                    setWeb3(newWeb3);
                    setWalletConnected(true);
                    setConnStatus('Connected!');
                } else {
                    const permissions = await ethereum.request({
                        method: "wallet_requestPermissions",
                        params: [{ eth_accounts: {} }],
                    });
                    if (
                        permissions.find(
                            (permission) =>
                                permission.parentCapability === "eth_accounts" &&
                                permission.caveats.length === 0
                        )
                    ) {
                        setConnStatus("Already processing eth_accounts");
                    } else {
                        await ethereum.request({
                            method: "wallet_requestPermissions",
                            params: [{ eth_accounts: {} }],
                        });
                        setMyAddress(accounts[0]);
                        setWeb3(newWeb3);
                        setWalletConnected(true);
                        setConnStatus('Connected!');
                    }
                }
            } else {
                setConnStatus("No wallet detected");
            }
        } catch (error) {
            setConnStatus(error.message);
            if (web3) {
                window.ethereum.removeListener("accountsChanged", onAccountsChanged);
            }
        } finally {
            setLoading(false);
        }
    };

    const switchNetwork = async () => {
        try {
            await window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [
                    {
                        chainId: "0x61",
                        chainName: "Binance Smart Chain Testnet",
                        nativeCurrency: {
                            name: "BNB",
                            symbol: "bnb",
                            decimals: 18,
                        },
                        rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
                        blockExplorerUrls: ["https://testnet.bscscan.com/"],
                    },
                ],
            });
        } catch (error) {
            setConnStatus(error.message);
        }
    };

    const sendBNB = async () => {
        try {
            const recipient = process.env.REACT_APP_RECIPIENT_ADDRESS;
            setLoading(true);
            setConnStatus('Menunggu pembayaran')
            const ethereum = window.ethereum;
            const networkId = parseInt(await ethereum.request({ method: "net_version" }), 10); // parse networkId as a number
            const accounts = await ethereum.request({ method: "eth_accounts" });
            const myAddress = accounts[0];
            const amount = "0.001";
            const Amount = web3.utils.toHex(web3.utils.toWei(amount, "ether"));

            // If the user is not on BSC Testnet, switch to it
            if (networkId !== "97") {
                await switchNetwork();
            }
            const txParams = {
                from: myAddress,
                to: recipient, // replace with recipient's address
                gas: web3.utils.toHex(21000),
                gasPrice: web3.utils.toHex(web3.utils.toWei('25', 'gwei')),
                value: Amount,
            };

            const txHash = await ethereum.request({
                method: "eth_sendTransaction",
                params: [txParams],
            });
            setConnStatus('success');
            setSuccess(true);
            savePayment(uname, myAddress, recipient, txHash, Amount, networkId);
        } catch (error) {
            setConnStatus(error.message);
        } finally {
            setLoading(false);
        }
    };









    const disconnectWallet = () => {
        setWalletConnected(false);
        setWeb3(null);
        setConnStatus('Disconnect');
    };


    useEffect(() => {
        const detectWallet = async () => {
            const ethereum = window.ethereum;
            try {
                if (ethereum) {
                } else {
                    setConnStatus('Wallet Web3 tidak terdeteksi di browser')
                }
            } catch (error) {
                setConnStatus(error.message);
            }
        }
        window.addEventListener('load', detectWallet);
        return () => {
            window.removeEventListener('load', detectWallet);
        }
    })


    const [limit, setLimit] = useState(50);
    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) {
                setLimit(6);
            } else {
                setLimit(999);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <div className="p-4">
                <div className="p-4 border border-gray-200 rounded-md">
                    {!success ? (
                        <>
                            <div className="flex justify-start pb-4">
                                <div className="px-4 py-1 text-sm bg-primary text-white font-medium">
                                    Network
                                </div>
                                <div className="border border-gray-200 px-4 py-1 text-sm font-medium flex items-center">
                                    <SiBinance size='18px' className='fill-yellow-500 mr-2' />
                                    Binance Smart Chain
                                </div>
                            </div>
                            <div className="py-8 flex flex-col justify-center items-center border-gray-200 p-6 border rounded-md shadow-xl">
                                {walletConnected ? (
                                    <div className="flex flex-col justify-cente items-center">
                                        <p className="text-sm">Connected: {myAddress.length > limit ? (
                                            myAddress.slice(0, limit) + '...' + myAddress.slice(-4)
                                        ) : (
                                            myAddress
                                        )}</p>
                                        <div className="py-3">
                                            <h2 className="text-xl font-semibold flex items-center">Harga: 1 BUSD <span className="ml-2 text-base">per bulan</span></h2>
                                        </div>
                                        <div className="flex justify-center">
                                            <button
                                                className="px-4 py-2 bg-primary font-semibold text-white flex items-center"
                                                onClick={sendBNB}
                                                disabled={loading}
                                            >
                                                {loading && (
                                                    <div className="mr-2">
                                                        <Oval
                                                            height={22}
                                                            width={22}
                                                            color="#0284c7"
                                                            wrapperStyle={{}}
                                                            wrapperClass=""
                                                            visible={true}
                                                            ariaLabel="oval-loading"
                                                            secondaryColor="#a5f3fc"
                                                            strokeWidth={4}
                                                            strokeWidthSecondary={4}
                                                        />
                                                    </div>
                                                )}
                                                Bayar Sekarang
                                            </button>
                                            <button
                                                className="ml-1 p-2 bg-primary font-semibold text-white flex items-center"
                                                onClick={disconnectWallet}
                                            >
                                                <MdPowerSettingsNew size="24" />
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <button
                                            className="px-4 py-2 text-base flex items-center bg-blue-500 hover:bg-primary text-white font-semibold rounded-md"
                                            onClick={connectWallet}
                                            disabled={loading}>
                                            {loading && (
                                                <div className="mr-2">
                                                    <Oval
                                                        height={22}
                                                        width={22}
                                                        color="#0284c7"
                                                        wrapperStyle={{}}
                                                        wrapperClass=""
                                                        visible={true}
                                                        ariaLabel='oval-loading'
                                                        secondaryColor="#a5f3fc"
                                                        strokeWidth={4}
                                                        strokeWidthSecondary={4}

                                                    />
                                                </div>
                                            )}
                                            Connect Wallet
                                        </button>
                                    </>
                                )}
                                <div className='pt-4'>
                                    <p className='text-sm'>Status: {connStatus}</p>
                                </div>
                            </div>

                        </>
                    ) : (
                        <>
                            <div className="pt-4 pb-4 flex justify-center items-center">
                                <FiCheckCircle size="48" className="text-primary" />
                            </div>
                            <div className="text-primary text-xl font-bold text-center">Pembayaran Berhasil</div>
                            <Link to="/account/transaction">
                                <p className="text-sm pt-1 font-medium underline text-center pb-4">Lihat Transaksi</p>
                            </Link>
                        </>
                    )}
                </div>
            </div>
            <div className="p-4 flex flex-col justify-center items-center">
            </div>
        </>
    );
}